import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { UserSearchComponent } from '../../user/user-search/user-search.component';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-invoice-sale-filter',
  templateUrl: './invoice-sale-filter.component.html',
  styleUrls: ['./invoice-sale-filter.component.scss']
})
export class InvoiceSaleFilterComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public token: any = Math.floor(Math.random() * 99999999999999);
  public loading: boolean = false;
  public search_array: any = [];
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public server!: any;
  public server_main!: any;
  public type_task!: number;
  public user_id: number | any;
  public id!: number;
  public i!: number;
  public code!: number;
  public access_service!: number;
  public level!: number;
  public creator!: number;
  public expire!: boolean;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<InvoiceSaleFilterComponent>) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.creator = dialog_data.creator;
      this.create_form1();
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          invoice_number: dialog_data.search_array.invoice_number,
          comment: dialog_data.search_array.comment,
          invoice_date: dialog_data.search_array.invoice_date,
          settlement_date: dialog_data.search_array.settlement_date,
          user: dialog_data.search_array.user,
          user_title: dialog_data.search_array.user_title,
        });
      }
    }
  }//end consructor
  search() {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      invoice_number: this.form1_group.value.invoice_number,
      comment: this.form1_group.value.comment,
      invoice_date: this.form1_group.value.invoice_date,
      settlement_date: this.form1_group.value.settlement_date,
      user: this.form1_group.value.user,
      user_title: this.form1_group.value.user_title,
      export_excel: 1,
    })
  }
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'invoice_number': new FormControl(null),
      'comment': new FormControl(null),
      'invoice_date': new FormControl(null),
      'settlement_date': new FormControl(null),
      'user_title': new FormControl(null),
      'user': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
    });
  }
  check_access(type_task: any): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, res['result'][0].count);

        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.expire = res['expire'];
          this.loading = false;
          if (type_task == 1) {
          }
          if (type_task == 2) { }
          if (type_task == 3) { this.search(); }
          if (type_task == 4) { }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  //******************************************************************************************************************* */
  open_user(): any {
    const dialogRef = this.dialog.open(UserSearchComponent, {
      width: '40rem',
      height: 'auto',
      data: {
        'code': this.code,
        'user': this.form1_group.value.user,
        'creator': this.creator
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1_group.patchValue({
            'user_title': res.title,
            'user': res.id
          });
        }
      }
    )
  }
  //******************************************************************************************************************* */
  load_services(id: number): any {
    var code_id;
    if (id == 161) {
      code_id = 6098;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, code_id: code_id, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 161) {
            this.form1_group.patchValue({
              'user': res.id,
              'user_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number) {
    if (id == 161) {
      this.form1_group.patchValue({
        'user_title': null,
        'user': null
      })
    }
  }
  //******************************************************************************************************** */
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

